import React, {Component, Fragment} from 'react'
import {Redirect} from "react-router-dom"
import { Link } from 'react-router-dom';



class Logout extends Component {
    constructor(props) {
        super(props)
        window.localStorage.setItem("rotaAtual", '');
        this.props.history.push('/')
        this.logout()
    }

     redirect(){
        return <Redirect to="/" push={true} />
      }

    logout = () => {
        localStorage.removeItem('user')
    }

    render() {
        return <Redirect to="/" push={true} />
    }
}

export default Logout